function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContacted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Chat",
    d: "M6 12a5.973 5.973 0 0 1-2.952-.781 1.319 1.319 0 0 0-.664-.254.728.728 0 0 0-.23.038l-1.212.361a.452.452 0 0 1-.136.021.372.372 0 0 1-.3-.143.388.388 0 0 1-.056-.347l.4-1.346a.627.627 0 0 0-.04-.541 6.34 6.34 0 0 1-.81-3 6.1 6.1 0 0 1 1.7-4.19A5.934 5.934 0 0 1 6.012 0a5.919 5.919 0 0 1 4.272 1.8 6.035 6.035 0 0 1 1.26 1.909A5.934 5.934 0 0 1 12 5.991a6.083 6.083 0 0 1-.519 2.5 5.759 5.759 0 0 1-1.365 1.892A6.147 6.147 0 0 1 6 12zm2.754-6.754a.769.769 0 1 0 .768.769.769.769 0 0 0-.768-.769zm-2.777 0a.761.761 0 0 0-.756.763.768.768 0 1 0 .768-.763h-.012zm-2.754 0a.769.769 0 1 0 .768.769.77.77 0 0 0-.769-.769z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacted);
export default __webpack_public_path__ + "static/media/contacted.c56c3306.svg";
export { ForwardRef as ReactComponent };